import { useState } from "react";
import { toEmbed } from "../../pages/TechniquesRevisionPublic";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

function SkillVideo({ url, testId }) {
  const [open, setOpen] = useState(false);
  const embed = toEmbed(url);
  if (!embed) return <a href={url} target="_blank" rel="noreferrer" className="ml-6 inline-block text-xs text-amber-300 underline" data-testid={testId}>🎬 Voir la vidéo de la technique</a>;
  return (
    <div className="ml-6 mt-1">
      {!open
        ? <button onClick={() => setOpen(true)} className="text-xs text-amber-300 underline" data-testid={testId}>🎬 Voir la vidéo de la technique</button>
        : <iframe src={embed} title="Vidéo technique" allow="autoplay; fullscreen" allowFullScreen className="w-full aspect-video rounded-lg border border-white/10 bg-black" data-testid={`${testId}-frame`} />}
    </div>
  );
}

// Carnet de progression vu par le parent (badges + certificats téléchargeables).
export function ParentCarnet({ carnet, token }) {
  if (!carnet?.stages?.length) return null;
  return (
    <section className="rounded-2xl border border-white/10 bg-white/[0.04] p-4" data-testid="parent-carnet">
      <div className="flex justify-between items-center">
        <div className="text-xs uppercase tracking-widest text-zinc-400">{carnet.title}</div>
        <span className="text-sm font-semibold" data-testid="parent-carnet-pct">{carnet.pct} % · {carnet.badges_earned.length}/{carnet.stages.length} badges</span>
      </div>
      <p className="text-[11px] text-zinc-500 mt-1">{carnet.intro}</p>
      <div className="grid grid-cols-4 gap-2 mt-3">
        {carnet.stages.map((st) => (
          <div key={st.id} className="text-center" data-testid={`parent-badge-${st.id}`}>
            <img src={st.badge} alt={st.name} className={`w-full aspect-square rounded-full ${st.certified ? "drop-shadow-[0_0_14px_rgba(255,255,255,0.25)]" : "grayscale opacity-40"}`} />
            <div className="text-[11px] mt-1 font-semibold" style={{ color: st.certified ? st.color : undefined }}>{st.name}</div>
            <div className="text-[10px] text-zinc-500">{st.certified ? "🏅 obtenu" : `${st.done}/${st.total}`}</div>
          </div>
        ))}
      </div>
      <div className="mt-4 space-y-2">
        {carnet.stages.map((st) => (
          <details key={st.id} className="rounded-lg border border-white/10 px-3 py-2" open={st.id === carnet.current_stage}>
            <summary className="text-sm cursor-pointer flex items-center justify-between gap-2">
              <span><span style={{ color: st.color }} className="font-semibold">{st.name}</span> <span className="text-zinc-400">— {st.subtitle}</span></span>
              {st.certified
                ? <span className="flex items-center gap-2"><a href={`${API}/samourais/public/parent/${token}/certificate/${st.id}.pdf`} target="_blank" rel="noreferrer" className="text-xs text-amber-300 underline" data-testid={`parent-cert-${st.id}`}>📜 Certificat PDF</a>{st.certificate?.handed_at && <span className="text-[10px] text-zinc-400" data-testid={`parent-handed-${st.id}`}>remis au dojo le {st.certificate.handed_at.slice(0, 10)}</span>}</span>
                : <span className="text-xs text-zinc-500">{st.done}/{st.total}</span>}
            </summary>
            <ul className="mt-2 space-y-2">
              {st.skills.map((s) => (
                <li key={s.id} className={`text-sm ${s.done ? "text-emerald-200" : "text-zinc-400"}`} data-testid={`parent-skill-${s.id}`}>
                  <div className="flex gap-2"><span>{s.done ? "✓" : "○"}</span><span>{s.label}{s.hint && <span className="block text-[11px] text-zinc-500">{s.hint}</span>}</span></div>
                  {s.video_url && <SkillVideo url={s.video_url} testId={`parent-video-${s.id}`} />}
                </li>
              ))}
            </ul>
          </details>
        ))}
      </div>
    </section>
  );
}
